import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Card, Form, Row, Col } from "react-bootstrap";
import { CLASS_NAME, CLASS_GROUP, BRANCH, CLASS_ROOM,NOTIFICATION_TYPES, STUDENTS_GROUP ,SUBJECTS_LIST, PAYMENT_DUE_NOTIFICATIN, PAYMENT_DUE_TEMPLATE, HOLIDAY} from "../constants";
import { useForm, useFormState, Controller } from "react-hook-form";
import { MultiSelect } from "react-multi-select-component";
// import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ReactSelect from "react-select";
import { fetchBranchClassGroups,branchClassGroupLevelClassRoomsAction , resetBranchLevelClassGroups , resetBranchClassGroupLevelClassRooms } from "../../redux/actions/feesActions";
import { smsTemplateAction, studentGroupAction } from "../../redux/actions/notificationAction";
import CreatableSelect from 'react-select/creatable';



const CreateNotification = (props) => {
  const { data, selectedEvent, branchData } = props;
  const dispatch = useDispatch()
  const { branchLevelClassGroups ,branchClassGroupLevelClassRooms ,loader } =useSelector((state) => state.fees);
  const { studentsGroupList , msgTemplate } =useSelector((state) => state.notification);
  console.log(studentsGroupList)
  const [show, setShow] = useState(props.show);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [selectedClassGroup, setSelectedClassGroup] = useState({});
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [subjectName, setSubjectName] = useState(null);
  
  let validationSchema = Yup.object().shape({
    BranchId: Yup.object().required("Branch Name is required").nullable(),
    subject: Yup.string().required("Subject Name is required"),
    content: Yup.string().required("Message is required"),
    notifiableType: Yup.string().default(BRANCH),
    notificationType: Yup.object().required("Notification Type is required").nullable(),
  });
  if (selectedEvent === CLASS_GROUP) {
    validationSchema = Yup.object().shape({
      BranchId: Yup.object().required("Branch Name is required").nullable(),
      ClassGroupId: Yup.object().required("ClassGroup Name is required").nullable(),
      subject: Yup.string().required("Subject Name is required"),
      content: Yup.string().required("Message is required"),
      notifiableType: Yup.string().default(CLASS_GROUP),
      notificationType: Yup.object().required("Notification Type is required").nullable(),
    });
  } else if (selectedEvent === CLASS_NAME) {
    validationSchema = Yup.object().shape({
      BranchId: Yup.object().required("Branch Name is required").nullable(),
      ClassGroupId: Yup.object()
        .required("Class Group Name is required")
        .nullable(),
      ClassRoomId: Yup.object().required("Class Room is required ").nullable(),
      subject: Yup.string().required("Subject Name is required"),
      content: Yup.string().required("Message is required"),
      notifiableType: Yup.string().default(CLASS_NAME),
      notificationType: Yup.object().required("Notification Type is required").nullable(),
    });
  }else if (selectedEvent === STUDENTS_GROUP) {
    validationSchema = Yup.object().shape({
      BranchId: Yup.object().required("Branch Name is required").nullable(),
      ClassGroupId: Yup.object()
        // .required("Class Group Name is required")
        .nullable(),
      ClassRoomId: Yup.object().nullable(),
      // subject: Yup.string().required("Subject Name is required"),
      subject: Yup.object().required("Subject Name is required").nullable(),
      content: Yup.string().required("Message is required").nullable(),
      notifiableType: Yup.string().default(STUDENTS_GROUP),
      notificationType: Yup.object().required("Notification Type is required").nullable(),
      notifiers_list: Yup.array()
      .of(
        Yup.object().shape({
          value: Yup.string(),
          label: Yup.string(),
        })
      ),
      holiday_date: Yup.string().ensure()
      .when("subject", {
        is: HOLIDAY,
        then: Yup.string().required("Holiday Date is required "),
      }),
      // .required("Notification Type is required"),
    });
  }
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setError,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const branchWatch = watch("BranchId");
  const classGroupWatch = watch("ClassGroupId");
  const classRoomWatch = watch("ClassRoomId");
  const subjectWatch = watch("subject");
  useEffect(() => {
    setShow(props.show);
    reset();
  }, [props.show]);
  useEffect(() => {
    setValue("content", msgTemplate);
    console.log(msgTemplate)
  }, [msgTemplate])
  
  useEffect(async() => {
    if (branchWatch) {
      switch (selectedEvent) {
        case BRANCH:
          break;
        case CLASS_GROUP:
          onChangeAction(branchWatch);

          break;
        case CLASS_NAME:
          onBranchChangeAction(branchWatch);
          break;
        case STUDENTS_GROUP:
            await onBranchChangeAction(branchWatch);
            setSelectedStudents([])
            await dispatch(studentGroupAction({
              BranchId: branchWatch.value
            }))
            break;
        default:
          break;
      }
    }
  }, [branchWatch]);
  useEffect(async() => {
    if (subjectWatch) {
     console.log(subjectWatch)
     if(subjectWatch){
      setSubjectName(subjectWatch.value)
      await dispatch(smsTemplateAction({
        subject: subjectWatch.value
      }))
      console.log(msgTemplate)
      //  setValue("subject",subjectWatch)
      //   if(subjectWatch.value === PAYMENT_DUE_NOTIFICATIN){
      //     setValue("content", PAYMENT_DUE_TEMPLATE)
      //   }else{
      //     setValue("content",null)
      //   }
     }
     
    }else{
      console.log("Isfasfdas")
      setValue("content",null)
      setSubjectName(null)
    }
  }, [subjectWatch]);

  useEffect(async() => {
    if (classGroupWatch) {
      switch (selectedEvent) {
        case BRANCH:
          break;
        case CLASS_GROUP:
          

          break;
        case CLASS_NAME:
          onChangeGroupNameAction(classGroupWatch);
          break;
        case STUDENTS_GROUP:
          console.log(getValues(["BranchId"]))
          await onChangeGroupNameAction(classGroupWatch);
          setSelectedStudents([])
          await dispatch(studentGroupAction({
            BranchId: getValues(["BranchId"])[0].value,
            ClassGroupId: classGroupWatch.value
          }))
            break;
        default:
          break;
      }
    }
  }, [classGroupWatch]);
  useEffect(async() => {
    if (classRoomWatch) {
      switch (selectedEvent) {
        case BRANCH:
          break;
        case CLASS_GROUP:
          break;
        case CLASS_NAME:
          break;
        case STUDENTS_GROUP:
          console.log(getValues("BranchId"))
          await onChangeRoomNameAction(classRoomWatch);
          setSelectedStudents([])
          await dispatch(studentGroupAction({
            BranchId: getValues(["BranchId"])[0].value,
            ClassGroupId: getValues("ClassGroupId").value,
            ClassRoomId: classRoomWatch.value
          }))
            break;
        default:
          break;
      }
    }
  }, [classRoomWatch]);

  const handleClose = () => {
    setShow(false);
    setSelectedStudents([])
    props.closeModal();
  };
  const handleShow = () => setShow(true);
  const onSubmit = async (data) => {
    console.log(data)
    let reqParams = {};
    if (selectedEvent === CLASS_GROUP) {
      reqParams = { ...data };
      reqParams.BranchId = data.BranchId.value;
      reqParams.ClassGroupId = data.ClassGroupId.value;
     
    } else if (selectedEvent === CLASS_NAME) {
      reqParams = { ...data };
      reqParams.BranchId = data.BranchId.value;
      reqParams.ClassGroupId = data.ClassGroupId.value;
      reqParams.ClassRoomId = data.ClassRoomId.value;
    }else if (selectedEvent === STUDENTS_GROUP) {
      reqParams = { ...data };
      reqParams.subject = data.subject ? data.subject.value : null ;
      reqParams.BranchId = data.BranchId ? data.BranchId.value : null ;
      reqParams.ClassGroupId = data.ClassGroupId ? data.ClassGroupId.value : null ;
      reqParams.ClassRoomId = data.ClassRoomId ? data.ClassRoomId.value : null ;
      reqParams.notifiers_list = selectedStudents.map(obj=> obj.value);
    } else {
      reqParams = { ...data };
      reqParams.BranchId = data.BranchId.value;
    }
    console.log(reqParams)
    if(selectedStudents.length > 0){
      reqParams.notifiableType = STUDENTS_GROUP;
    }else if(data.BranchId && !data.ClassGroupId ){
      reqParams.notifiableType = BRANCH;
    }else if (data.BranchId && data.ClassGroupId && !data.ClassRoomId){
      reqParams.notifiableType = CLASS_GROUP;
    }else if (data.BranchId && data.ClassGroupId && data.ClassRoomId && selectedStudents.length === 0){
      reqParams.notifiableType = CLASS_NAME;
    }
    reqParams.notificationType = data.notificationType.value;
    await props.create(reqParams);
    reset();
  };
  const onChangeAction = async(branchWatch) => {
    setValue("BranchId", branchWatch);
    setSelectedBranch(branchWatch)
    await dispatch(resetBranchLevelClassGroups())
   
    if (branchWatch && branchWatch.value ) {

      await dispatch(fetchBranchClassGroups({
        BranchId: branchWatch.value,
        disabled: false
      }))
      
      }
  };
  const onBranchChangeAction = async(branchWatch) => {
    setValue("BranchId", branchWatch);
    await dispatch(resetBranchLevelClassGroups())
    await dispatch(resetBranchClassGroupLevelClassRooms())
    if (
      branchWatch &&
      branchWatch.value 
    ) {
      setSelectedBranch(branchWatch)
      setValue("ClassGroupId",null)
      setValue("ClassRoomId",null)
      await dispatch(fetchBranchClassGroups({
        BranchId: branchWatch.value,
        disabled: false
      }))
      }else{
        setValue("ClassGroupId",null)
        setValue("ClassRoomId",null)
      }
  };
  const onChangeGroupNameAction = async(groupWatch) => {
    console.log(groupWatch)
    setValue("ClassGroupId", groupWatch);
    setSelectedClassGroup(groupWatch);
    await dispatch(resetBranchClassGroupLevelClassRooms())
    if (groupWatch && groupWatch.value ) {
      setValue("ClassRoomId",null)
      await dispatch(branchClassGroupLevelClassRoomsAction({
        ClassGroupId: parseInt(groupWatch.value),
        BranchId: parseInt(selectedBranch.value),
        disabled: false
      }))
    }else{
      setValue("ClassRoomId",null)
    }
  };
  const onChangeRoomNameAction = async(roomWatch) => {
    console.log(roomWatch)
    setValue("ClassRoomId", roomWatch);
  };

  const renderSwitch = (param) => {
    switch (selectedEvent) {
      case BRANCH:
        return (
          <>
          <Form.Row>
            <Form.Group
              className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
              controlId="formFirstName" 
            >
              <Form.Label className="label">Branch Name</Form.Label>
              <Controller
                    name="BranchId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <ReactSelect
                          isClearable
                          {...field}
                          options={branchData}
                          className={`${errors.BranchId ? "is-invalid" : ""}`}
                          // isOptionDisabled={(option) => option.disabled}
                        />
                        <span className="invalid-feedback">
                          {errors.BranchId?.message}
                        </span>
                      </>
                    )}
                    {...register("BranchId")}
                  />
            </Form.Group>
            <Form.Group
              className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
              controlId="formLastName"
            >
              <Form.Label className="label">Notification Type</Form.Label>
                  <Controller
                    name="notificationType"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <ReactSelect
                          isClearable
                          {...field}
                          options={NOTIFICATION_TYPES}
                          className={`${errors.notificationType ? "is-invalid" : ""}`}
                        />
                        <span className="invalid-feedback">
                          {errors.notificationType?.message}
                        </span>
                      </>
                    )}
                    {...register("notificationType")}
                  />
            </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4  required"
            controlId="formFirstName" 
          >
            <Form.Label className="label">Subject</Form.Label>
            <Form.Control
                  type="text"
                  name="subject"
                  className={`form-control ${
                    errors.subject ? "is-invalid" : ""
                  }`}
                  {...register("subject")}
                ></Form.Control>
                <span className="invalid-feedback">
                  {errors.subject?.message}
                </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 offset-xl-2 required"
            controlId="formLastName"
          >
            <Form.Label className="label">Message</Form.Label>
            <Form.Control
                  as="textarea"
                  rows={3}
                  name="content"
                  className={`form-control ${
                    errors.content ? "is-invalid" : ""
                  }`}
                  {...register("content")}
                ></Form.Control>
                <span className="invalid-feedback">
                  {errors.content?.message}
                </span>
          </Form.Group>
        </Form.Row>
          </>
        );
      case CLASS_GROUP:
        return (
          <>
            <Form.Row>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                controlId="formFirstName" 
              >
                <Form.Label className="label">Select Branch Name</Form.Label>
                  <Controller
                    name="BranchId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <ReactSelect
                          isClearable
                          {...field}
                          options={branchData}
                          className={`${errors.BranchId ? "is-invalid" : ""}`}
                          // onChange={onChangeAction}
                        />
                        <span className="invalid-feedback">
                          {errors.BranchId?.message}
                        </span>
                      </>
                    )}
                    {...register("BranchId")}
                  />
              </Form.Group>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                controlId="formLastName"
              >
                <Form.Label className="label">Select ClassGroup Name</Form.Label>
                  <Controller
                      name="ReactSelect"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <ReactSelect
                            isClearable
                            {...field}
                            options={branchLevelClassGroups}
                            className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                          />
                          <span className="invalid-feedback">
                            {errors.ClassGroupId?.message}
                          </span>
                        </>
                      )}
                      {...register("ClassGroupId")}
                    />
              </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Notification Type</Form.Label>
                  <Controller
                      name="notificationType"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <ReactSelect
                            isClearable
                            {...field}
                            options={NOTIFICATION_TYPES}
                            className={`${errors.notificationType ? "is-invalid" : ""}`}
                          />
                          <span className="invalid-feedback">
                            {errors.notificationType?.message}
                          </span>
                        </>
                      )}
                      {...register("notificationType")}
                    />
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                  controlId="formLastName"
                >
                  <Form.Label className="label">Subject</Form.Label>
                  <Form.Control
                      type="text"
                      name="subject"
                      className={`form-control ${
                        errors.subject ? "is-invalid" : ""
                      }`}
                      {...register("subject")}
                    ></Form.Control>
                    <span className="invalid-feedback">
                      {errors.subject?.message}
                    </span>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Message</Form.Label>
                  <Form.Control
                      as="textarea"
                      rows={3}
                      name="content"
                      className={`form-control ${
                        errors.content ? "is-invalid" : ""
                      }`}
                      {...register("content")}
                    ></Form.Control>
                    <span className="invalid-feedback">
                      {errors.content?.message}
                    </span>
                </Form.Group>
            </Form.Row>
          </>
        );
      case CLASS_NAME:
        return (
          <>
          <Form.Row>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                controlId="formFirstName" 
              >
                <Form.Label className="label">Select Branch Name</Form.Label>
                  <Controller
                    name="BranchId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <ReactSelect
                          isClearable
                          {...field}
                          options={branchData}
                          className={`${errors.BranchId ? "is-invalid" : ""}`}
                          // onChange={onChangeAction}
                        />
                        <span className="invalid-feedback">
                          {errors.BranchId?.message}
                        </span>
                      </>
                    )}
                    {...register("BranchId")}
                  />
              </Form.Group>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                controlId="formLastName"
              >
                <Form.Label className="label">Select ClassGroup Name</Form.Label>
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchLevelClassGroups}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        // onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Select ClassRoom</Form.Label>
                  <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchClassGroupLevelClassRooms}
                        className={`${errors.ClassRoomId ? "is-invalid" : ""}`}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassRoomId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassRoomId")}
                />
                  
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                  controlId="formLastName"
                >
                  <Form.Label className="label">Notification Type</Form.Label>
                  <Controller
                      name="notificationType"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <ReactSelect
                            isClearable
                            {...field}
                            options={NOTIFICATION_TYPES}
                            className={`${errors.notificationType ? "is-invalid" : ""}`}
                          />
                          <span className="invalid-feedback">
                            {errors.notificationType?.message}
                          </span>
                        </>
                      )}
                      {...register("notificationType")}
                    />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Subject</Form.Label>
                  <Form.Control
                      type="text"
                      name="subject"
                      className={`form-control ${
                        errors.subject ? "is-invalid" : ""
                      }`}
                      {...register("subject")}
                    ></Form.Control>
                    <span className="invalid-feedback">
                      {errors.subject?.message}
                    </span>
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                  controlId="formLastName"
                >
                  <Form.Label className="label">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="content"
                    className={`form-control ${
                      errors.content ? "is-invalid" : ""
                    }`}
                    {...register("content")}
                  ></Form.Control>
                  <span className="invalid-feedback">
                    {errors.content?.message}
                  </span>
                  
                </Form.Group>
            </Form.Row>
          </>
        );
        break;
      case STUDENTS_GROUP:
          return (
            <>
            <Form.Row>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                controlId="formFirstName" 
              >
                <Form.Label className="label">Select Branch Name</Form.Label>
                  <Controller
                    name="BranchId"
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <>
                        <ReactSelect
                          isClearable
                          {...field}
                          options={branchData}
                          className={`${errors.BranchId ? "is-invalid" : ""}`}
                          // onChange={onChangeAction}
                        />
                        <span className="invalid-feedback">
                          {errors.BranchId?.message}
                        </span>
                      </>
                    )}
                    {...register("BranchId")}
                  />
              </Form.Group>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                controlId="formLastName"
              >
                <Form.Label className="label">Select ClassGroup Name</Form.Label>
                <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchLevelClassGroups}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        // onChange={onChangeGroupNameAction}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
              </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Select ClassRoom</Form.Label>
                  <Controller
                  name="ReactSelect"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchClassGroupLevelClassRooms}
                        className={`${errors.ClassRoomId ? "is-invalid" : ""}`}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassRoomId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassRoomId")}
                />
                  
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                  controlId="formLastName"
                >
                  <Form.Label className="label">Select Students</Form.Label>
                  <MultiSelect
                  name="notifiers_list"
                  options={studentsGroupList}
                  value={selectedStudents}
                  onChange={setSelectedStudents}
                  labelledBy="Select"
                  // {...register("notifiers_list")}
                />
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Notification Type</Form.Label>
                  <Controller
                      name="notificationType"
                      control={control}
                      rules={{ required: true }}
                      render={({ field }) => (
                        <>
                          <ReactSelect
                            isClearable
                            {...field}
                            options={NOTIFICATION_TYPES}
                            className={`${errors.notificationType ? "is-invalid" : ""}`}
                          />
                          <span className="invalid-feedback">
                            {errors.notificationType?.message}
                          </span>
                        </>
                      )}
                      {...register("notificationType")}
                    />
                  
                </Form.Group>
                <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                  controlId="formLastName"
                >
                  <Form.Label className="label">Subject</Form.Label>
                  <Controller
                  name="subject"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <CreatableSelect
                        isClearable
                        {...field}
                        className={`${errors.subject ? "is-invalid" : ""}`}
                        options={SUBJECTS_LIST}
                        placeholder="Type Subject name..."
                      />
                      <span className="invalid-feedback">
                        {errors.subject?.message}
                      </span>
                    </>
                  )}
                  {...register("subject")}
                /> 
                  {/* <Form.Control
                      type="text"
                      name="subject"
                      className={`form-control ${
                        errors.subject ? "is-invalid" : ""
                      }`}
                      {...register("subject")}
                    ></Form.Control>
                    <span className="invalid-feedback">
                      {errors.subject?.message}
                    </span> */}
                  
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group
                  className={ subjectName === HOLIDAY ? "col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4   required" : "col-xs-12 col-sm-12 col-md-9  col-lg-10  col-xl-10   required" }
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Message </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    name="content"
                    className={`form-control ${
                      errors.content ? "is-invalid" : ""
                    }`}
                    {...register("content")}
                    disabled={[PAYMENT_DUE_NOTIFICATIN,HOLIDAY].includes(subjectName)}
                  ></Form.Control>
                  <span className="invalid-feedback">
                    {errors.content?.message}
                  </span>
                  
                </Form.Group>
                {subjectName === HOLIDAY ? (
                  <Form.Group
                  className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-4 offset-xl-2 required"
                  controlId="formFirstName" 
                >
                  <Form.Label className="label">Holiday Date </Form.Label>
                  <Form.Control
                    type="date"
                    name="holiday_date"
                    className={`form-control ${
                      errors.holiday_date ? "is-invalid" : ""
                    }`}
                    {...register("holiday_date")}
                  ></Form.Control>
                  <span className="invalid-feedback">
                    {errors.holiday_date?.message}
                  </span>
                  
                </Form.Group>
                ) : null }
                
            </Form.Row>
            
              
            </>
          );
      default:
        return "foo";
    }
  };

  return (
    <>
      <Modal show={show} size="xl" onHide={handleClose}>
        <Form noValidate onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Create {selectedEvent} Notification </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Card>
              <Card.Header> Notification Form </Card.Header>
              <Card.Body>
                {renderSwitch()}
                <div className="text-center"></div>
              </Card.Body>
            </Card>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              className="btn app-default-button btn btn-primary"
              type="submit"
            >
              Create {selectedEvent} Notifcation
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default CreateNotification;